import React, { useState } from 'react'
import Imgix from 'react-imgix'
import { useResolutionService } from '@abroad/components'
import { ModuleMiniDetails } from '../breakthrough'
import { getFormattedDateRange, getProgramDatesRange } from '../../utils/date'

const QuestDetail = ({ questHomeId, questHome }) => {
  const { isMDScreen } = useResolutionService()
  const [expanded, setExpanded] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const imgSrc = questHome?.imageFileName
    ? `${process.env.REACT_APP_IMG_SOURCE}/quest/${questHome?.imageFileName}`
    : null

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const getDescription = () => {
    if (expanded) {
      return questHome?.description
    } else {
      return questHome?.description.length > 550
        ? questHome?.description.slice(0, 550) + '...'
        : questHome?.description
    }
  }

  const { start: dateStart, end: dateEnd } = getProgramDatesRange(questHome)
  const formattedDateRange = getFormattedDateRange(dateStart, dateEnd)

  return (
    <>
      {imgSrc ? (
        <div className={loaded ? 'quest-fade-in' : 'quest-fade-out'}>
          <Imgix
            className='border-radius-10 mt-32px lazyload imgix-object-cover'
            imgixParams={{
              fit: 'crop',
              crop: 'edges',
              ar: isMDScreen ? '2:1' : '5:2',
            }}
            src={imgSrc}
            width={'100%'}
            alt='image'
            attributeConfig={{
              src: 'data-src',
              srcSet: 'data-srcset',
              sizes: 'data-sizes',
            }}
            htmlAttributes={{
              src: `${imgSrc}?ar=${
                isMDScreen ? '2:1' : '5:2'
              }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`,
              loading: 'lazy',
              onLoad: () => setLoaded(true),
              onError: () => setLoaded(true),
            }}
          />
          <div className='mt-24px'>
            <ModuleMiniDetails
              showDots={false}
              details={{
                label1: formattedDateRange,
              }}
            />
            <div className='s2 my-16px'>
              <span className='fst-italic'>{questHome?.title}</span>
            </div>
            <pre
              onClick={(e) => {
                e.stopPropagation()
                toggleExpand()
              }}
              className='s7 mb-0 pre'
              dangerouslySetInnerHTML={{ __html: getDescription() }}
            />
          </div>
        </div>
      ) : (
        <div>
          <div className='mt-24px'>
            <ModuleMiniDetails
              showDots={false}
              details={{
                label1: formattedDateRange,
              }}
            />
            <div className='s2 my-16px'>
              <span className='fst-italic'>{questHome?.title}</span>
            </div>
            <pre
              onClick={(e) => {
                e.stopPropagation()
                toggleExpand()
              }}
              className='s7 mb-0 pre'
              dangerouslySetInnerHTML={{ __html: getDescription() }}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default QuestDetail
